export const checkValueAndLength = (value: string | undefined | null, defaultValue: string | null = '-') => {
  return value && value.length > 0 ? value : defaultValue;
};

export const makeAlphabetUpperCase = (value: string) => {
  return value.replace(/[a-z]/g, (char: string) => char.toUpperCase());
};
